import React from 'react';
import {
  DataBox,
  DataBoxBaseProps,
  DataBoxLegendProps,
} from 'src/components/molecules/DataBox';
import { NewAreaGraph } from 'src/components/molecules/graphs/NewAreaGraph';
import {
  MonthYearDateFormatter,
  ValueTickFormatter,
} from 'src/utils/TickFormatters';
import { ChartRow } from '../../utils/shareOfSearch';

type SearchVolumeBoxProps = DataBoxBaseProps & {
  data: ChartRow[];
  keywords: string[];
  brandKeyword: string | null;
  isLoading: boolean;
  isError: boolean;
};

export const SearchVolumeBox: React.FC<SearchVolumeBoxProps> = ({
  data,
  keywords,
  brandKeyword,
  isLoading,
  isError,
  ...props
}) => {
  const legendProps: DataBoxLegendProps = {
    baseLegendKeys: keywords,
    placement: 'top',
  };

  return (
    <DataBox
      {...props}
      legendProps={legendProps}
      isError={isError}
      isLoading={isLoading}
      restrictChartHeight
      topLegendOnLeft
      hasData={data.length > 0}>
      <NewAreaGraph
        data={data}
        xAxisKey="key"
        benchmarkKey={brandKeyword ?? undefined}
        xAxisFormatter={MonthYearDateFormatter}
        yAxisFormatter={ValueTickFormatter}
      />
    </DataBox>
  );
};
